export const SKU_MODEL_ORIGIN_ORIGINAL = "Pièce Originale";
export const SKU_TYPE_NEW = "new";
export const SKU_TYPE_SECOND_HAND = "second_hand";
